<template>
  <b-card class="animated fadeIn my-1">
    <template #header>
      <i class="fas fa-cogs"></i>
      <span class="pl-1">{{$lang.PCI.Items.ValidationStatusAutomation.Title}}</span>
    </template>
    <b-button variant="default"
              class="mb-1"
              @click="onNewStatus">
      <i class="fas fa-plus-circle"></i>
      <!-- <span>{{$lang.Common.Buttons.New}}</span> -->
    </b-button>
    <add-valid-autom-rules :objList="hierarcList"
                           :form="form"
                           :searchingItem="searchingItem"
                           :searchingCompareItem="searchingCompareItem"
                           :itemIndex="itemIndex"
                           :tipo="tipo"
                           @move="onMove"
                           @change-father="onChangeFather"
                           @change-position="onChangePosition"
                           @remove="onRemove"
                           @open-modal="onOpenModalItems"
                           @open-modal-compare="onOpenModalCompareItems"
                           @update="onUpdate"
                           @validation-warning="onValidationWarning">
    </add-valid-autom-rules>
    <b-modal ref="modalItems"
              :title="$lang.PCI.Items.ValidationStatusAutomation.ModalItemsTitle"
              :hide-footer="true"
              no-close-on-backdrop
              no-close-on-esc
              @close="onCloseModalItems">
      <b-tabs>
        <b-tab>
          <template #title><i class="fas fa-list"></i> {{ $lang.PCI.Reports.Item.ItemType0 }}</template>
          <div id="modalItems" class="d-flex flex-column align-items-center">
            <i class="fas fa-trash text-danger pointer" style="font-size: 1rem;" @click="onSelectItem(null)"></i>
            <item-tree-view ref="itemTreeview"
                            :list="form.pciModeloItem.options"
                            :serializer="it => `(${it.value}) ${it.name}`"
                            @selectitem="onSelectItem" />
          </div>
        </b-tab>
        <b-tab>
            <template #title><i class="fas fa-thumbtack"></i> {{ $lang.PCI.Reports.Item.ItemType1 }}</template>
            <div v-for="item in form.pciItemFixo.options" :key="item.code">
              <div class="mt-2" v-if="(item.code % 10) === 0">
                <strong>{{ item.text }}</strong>
              </div>
              <div v-else>
                <a href="#" class="text-secondary ml-3" @click="onSelectFixedItem(item)">{{ item.text }}</a>
              </div>
            </div>
          </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal ref="modalCompareItems"
              :title="$lang.PCI.Items.ValidationStatusAutomation.ModalItemsTitle"
              :hide-footer="true"
              no-close-on-backdrop
              no-close-on-esc
              @close="onCloseModalCompareItems">
      <b-tabs>
        <b-tab>
          <template #title><i class="fas fa-list"></i> {{ $lang.PCI.Reports.Item.ItemType0 }}</template>
          <div id="modalCompareItems" class="d-flex flex-column align-items-center">
            <i class="fas fa-trash text-danger pointer" style="font-size: 1rem;" @click="onSelectCompareItem(null)"></i>
            <item-tree-view ref="compareItemTreeview"
                            :list="form.pciModeloItemComparar.options"
                            :serializer="it => `(${it.value}) ${it.name}`"
                            v-on:selectitem="onSelectCompareItem" />
          </div>
        </b-tab>
        <b-tab>
          <template #title><i class="fas fa-thumbtack"></i> {{ $lang.PCI.Reports.Item.ItemType1 }}</template>
          <div v-for="item in form.pciItemFixo.options" :key="item.code">
            <div class="mt-2" v-if="(item.code % 10) === 0">
              <strong>{{ item.text }}</strong>
            </div>
            <div v-else>
              <a href="#" class="text-secondary ml-3" @click="onSelectCompareFixedItem(item)">{{ item.text }}</a>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>

    <!--Seleção de Grupos notificação por valor-->
    <!-- <div v-if="tipo === tipoEnum.AUTOMATION">
      <hr style="margin-top: 0;"/>
      <b-form-checkbox v-model="value.gerarNotificacao" name="check-button" switch>
        {{$lang.PCI.Items.ValidationStatusAutomation.LabelNotificationsGroup}}
        <b>
          {{ value.gerarNotificacao ?
            $lang.PCI.Items.ValidationStatusAutomation.LabelEnables :
            $lang.PCI.Items.ValidationStatusAutomation.LabelDisables }}
        </b>
      </b-form-checkbox>
      <div id="notificationGroupTag">
        <div class="d-flex flex-row align-items-center py-1">
          <b-form-select :options="notificationGroupList"
                          v-model="selected"
                          class="mr-2" ref="notifyList">
            <template #first>
              <b-form-select-option :value="null">
                {{$lang.PCI.Items.ValidationStatusAutomation.PlaceholderNotifyGroup}}
              </b-form-select-option>
            </template>
          </b-form-select>
          <i class="fa fa-plus-circle text-third p-1"
              style="cursor: pointer; font-size: 1rem;"
              @click="onNewNotifyGroup">
          </i>
        </div>
        <div class="card d-flex flex-row mb-1" v-for="(val, index) in value.statusValorGrupos" :key="index">
          <span class="col-11">{{val.name}}</span>
          <i class="fa fa-trash text-danger p-1 col-1"
              style="cursor: pointer; font-size: 1rem;"
              @click="onRemoveNotifyGroup(index)">
          </i>
        </div>
      </div>
    </div> -->
  </b-card>
</template>

<script>
import ItemTreeView from '../components/treeview/ItemTreeView.vue'
import addValidAutomRules from './addValidAutomRules.vue'
import actionsForm from '@/shared/mixins/actionsForm'
import addStatusForm from './addValidationAutomation-form'
import CompanyMixin from '@/store/module/company/mixin'
import itemMixim from '../mixins/itemMixim'
// import { loading, toast } from '@/shared/utils/UIHelper'
// import NotificationGroupRepository from '@/shared/http/repositories/access/notificationgroup'
import PCIItemRepository from '@/shared/http/repositories/pci/pciItem'
import { v4 } from 'uuid'
import { cloneDeep } from 'lodash'

export default {
  name: 'AddValidationAutomation',
  props: {
    value: Object,
    itemList: Array,
    tipo: String
  },
  mixins: [ actionsForm, CompanyMixin, itemMixim ],
  components: {
    ItemTreeView,
    addValidAutomRules
  },
  data () {
    return {
      form: addStatusForm,
      data: null,
      objList: [],
      hierarcList: [],
      obj: {},
      itemIndex: -1,
      itemModal: null,
      searchingItem: false,
      searchingCompareItem: false,
      tipoEnum: {
        VALIDATION: 'VALIDATION',
        AUTOMATION: 'AUTOMATION'
      },
      selected: null,
      notificationGroupList: []
    }
  },
  methods: {
    onLoad () {
      const getRulesHierarchy = (list) => {
        let map = {}
        let node = {}
        let roots = []
        let field = ''
        if (this.tipo === this.tipoEnum.VALIDATION) {
          field = 'pciModeloItemValidRegraIDPai'
        } else if (this.tipo === this.tipoEnum.AUTOMATION) {
          field = 'pciModeloItemStatusRegraIDPai'
        }

        for (let i in list) {
          map[list[i].id] = i // initialize the map
          list[i].regras = []
        }

        for (let i in list) {
          // Stores current node
          node = list[i]
          // Verifies if node has a parent
          if (node[field]) {
            // Verifies if node parent exists
            if (list[map[node[field]]]) {
              if (list[map[node[field]]].regras) {
                // Add this node to his parent
                list[map[node[field]]].regras.push(node)
              } else {
                list[map[node[field]]].regras = [node]
              }
            }
          } else {
            // Add a new node in roots
            roots.push(node)
          }
        }
        return roots
      }

      if (this.tipo === this.tipoEnum.VALIDATION) {
        this.objList = this.value.regrasValid
      } else if (this.tipo === this.tipoEnum.AUTOMATION) {
        this.objList = this.value.regrasStatus
      }
      this.hierarcList = getRulesHierarchy(cloneDeep(this.objList))
      this.form.tipoOperadorLogico.options = [
        {value: 0, text: this.$lang.PCI.Items.ValuesLogicalOperator.None},
        {value: 1, text: this.$lang.PCI.Items.ValuesLogicalOperator.And},
        {value: 2, text: this.$lang.PCI.Items.ValuesLogicalOperator.Or}
      ]
      this.form.tipoValidacao.options = [
        {value: '0', text: ' - '},
        {value: '1', html: this.$lang.PCI.Items.ValuesValidationType.NotNull},
        {value: '2', html: this.$lang.PCI.Items.ValuesValidationType.Null},
        {value: '3', html: this.$lang.PCI.Items.ValuesValidationType.NotNA},
        {value: '4', html: this.$lang.PCI.Items.ValuesValidationType.NA},
        {value: '10', html: this.$lang.PCI.Items.ValuesValidationType.EqualsConstant},
        {value: '11', html: this.$lang.PCI.Items.ValuesValidationType.GreaterThanConstant},
        {value: '12', html: this.$lang.PCI.Items.ValuesValidationType.LessThanConstant},
        {value: '13', html: this.$lang.PCI.Items.ValuesValidationType.GreaterThanOrEqualsConstant},
        {value: '14', html: this.$lang.PCI.Items.ValuesValidationType.LessThanOrEqualsConstant},
        {value: '15', html: this.$lang.PCI.Items.ValuesValidationType.DifferentFromConstant},
        {value: '16', html: this.$lang.PCI.Items.ValuesValidationType.ContainsConstant},
        {value: '17', html: this.$lang.PCI.Items.ValuesValidationType.DaysToTodayGreaterThanConstant},
        {value: '18', html: this.$lang.PCI.Items.ValuesValidationType.DaysToTodayLessThanConstant},
        {value: '50', html: this.$lang.PCI.Items.ValuesValidationType.EqualsItem},
        {value: '51', html: this.$lang.PCI.Items.ValuesValidationType.GreaterThanItem},
        {value: '52', html: this.$lang.PCI.Items.ValuesValidationType.LessThanItem},
        {value: '53', html: this.$lang.PCI.Items.ValuesValidationType.GreaterThanOrEqualsItem},
        {value: '54', html: this.$lang.PCI.Items.ValuesValidationType.LessThanOrEqualsItem},
        {value: '55', html: this.$lang.PCI.Items.ValuesValidationType.DifferentFromItem},
        {value: '56', html: this.$lang.PCI.Items.ValuesValidationType.DaysToItemGreaterThanConstant},
        {value: '57', html: this.$lang.PCI.Items.ValuesValidationType.DaysToItemLessThanConstant}
      ]
      this.form.pciModeloItem.options = this.getHierarchy(
        this.itemList.map(item => {
          return {
            id: item.id,
            name: item.descricao,
            value: item.codigo,
            parentId: item.itemPaiID,
            type: item.tipo,
            order: item.ordem,
            open: false,
            children: null
          }
        })
      )
      this.form.pciModeloItemComparar.options = this.getHierarchy(
        this.itemList.map(item => {
          return {
            id: item.id,
            name: item.descricao,
            value: item.codigo,
            parentId: item.itemPaiID,
            type: item.tipo,
            order: item.ordem,
            open: false,
            children: null
          }
        })
      )
      if (!this.value.gerarNotificacao) {
        this.value.gerarNotificacao = false
      }
      this.getNotificationGroups()
    },
    onSelect (obj) {
      this.data = obj
      this.onEdit(obj)
    },
    onClearForm () {
      this.data = null
    },
    onNewStatus () {
      const lastOrder = !(this.objList && this.objList.length) ? 1 : this.objList.reduce((prev, current) => {
        return (prev.ordem > current.ordem) ? prev : current
      }).ordem + 1

      const data = {
        id: v4(),
        pciModeloItem: null,
        pciModeloItemID: null,
        pciItemFixo: null,
        pciModeloItemComparar: null,
        pciModeloItemIDComparar: null,
        pciItemFixoComparar: null,
        tipoOperadorLogico: 0,
        status: 1,
        ordem: lastOrder,
        tipoValidacao: 0,
        constante: null,
        tolerancia: 0,
        regras: []
      }

      if (this.tipo === this.tipoEnum.VALIDATION) {
        data.pciModeloItemValidID = this.value.id
      } else if (this.tipo === this.tipoEnum.AUTOMATION) {
        data.pciModeloItemValorID = this.value.id
      }

      this.objList.push(data)
      // data.regras = []
      this.hierarcList.push(data)
    },
    onCreate () {
      // const data = this.data
      // this.data = null
      // this.$emit('Create', data)
    },
    onUpdate (obj) {
      const idx = this.objList.findIndex(l => l.id === obj.id)
      const obj2 = cloneDeep(obj)
      delete obj2.regras
      this.objList.splice(idx, 1, obj2)
    },
    onDelete (index) {
      // if (this.tipo === this.tipoEnum.VALIDATION) {
      //   this.value.regrasValid.splice(index, 1)
      //   this.objList = this.value.regrasValid
      //   if (!this.value.regrasValid.length) {
      //     this.$emit('Clean')
      //   }
      // } else if (this.tipo === this.tipoEnum.AUTOMATION) {
      //   this.value.regrasStatus.splice(index, 1)
      //   this.objList = this.value.regrasStatus
      //   if (!this.value.regrasStatus.length) {
      //     this.$emit('Clean')
      //   }
      // }
    },
    onMove (event) {
      console.log('move', event)
    },
    onChangeFather (params) {
      const idx = this.objList.findIndex(o => o.id === params.id)
      if (this.tipo === this.tipoEnum.VALIDATION) {
        const value = this.objList[idx]
        value.pciModeloItemValidRegraIDPai = params.fatherId
        value.pciModeloItemRegraBaseIDPai = params.fatherId
        this.$set(this.objList, idx, value)
      } else if (this.tipo === this.tipoEnum.AUTOMATION) {
        const value = this.objList[idx]
        value.pciModeloItemStatusRegraIDPai = params.fatherId
        value.pciModeloItemRegraBaseIDPai = params.fatherId
        this.$set(this.objList, idx, value)
      }
      this.onChangePosition()
      console.table(this.objList)
    },
    onChangePosition () {
      let order = 1

      const changeOrder = (list) => {
        list.forEach(it => {
          it.ordem = order
          const idx = this.objList.findIndex(o => o.id === it.id)
          const value = this.objList[idx]
          value.ordem = order++
          this.$set(this.objList, idx, value)
          if (it.regras && it.regras.length) {
            changeOrder(it.regras)
          }
        })
      }
      changeOrder(this.hierarcList)

      this.$nextTick(() => {
        this.$emit('changeList', this.objList)
      })
    },
    onOpenModalItems ({ obj, index }) {
      this.itemIndex = index
      this.obj = obj
      this.itemModal = this.$refs.modalItems
      this.$refs.modalItems.show()
    },
    onCloseModalItems () {
      this.itemIndex = -1
      this.itemModal = null
      this.onUpdate(this.obj)
      this.obj = {}
    },
    onSelectItem (item) {
      this.obj.pciItemFixo = null
      this.obj.pciModeloItemID = item ? item.id : null
      this.itemModal.hide()

      if (item) {
        this.searchingItem = true
        PCIItemRepository.Find(item.id)
          .then(response => {
            this.obj.pciModeloItem = response.data.data
            this.obj.pciModeloItem.valores = null
            this.obj.pciModeloItem.formula = null
            this.obj.pciModeloItem.validacoes = null

            this.onCloseModalItems()
          })
          .finally(() => {
            this.searchingItem = false
          })
      } else {
        this.obj.pciModeloItem = null
        this.obj.tipoValidacao = '0'
        this.obj.pciModeloItemComparar = null
        this.onCloseModalItems()
      }
    },
    onSelectFixedItem (item) {
      this.obj.pciModeloItemID = null
      this.itemModal.hide()

      if (item) {
        this.obj.pciItemFixo = item.code
      }
      this.onCloseModalItems()
    },
    onOpenModalCompareItems ({ obj, index }) {
      this.itemIndex = index
      this.obj = obj
      this.itemModal = this.$refs.modalCompareItems
      this.$refs.modalCompareItems.show()
    },
    onCloseModalCompareItems () {
      this.itemIndex = -1
      this.itemModal = null
      this.onUpdate(this.obj)
      this.obj = {}
    },
    onSelectCompareItem (item) {
      this.obj.pciItemFixoComparar = null
      this.obj.pciModeloItemIDComparar = item ? item.id : null
      this.itemModal.hide()

      if (item) {
        this.searchingCompareItem = true
        PCIItemRepository.Find(item.id)
          .then(response => {
            this.obj.pciModeloItemComparar = response.data.data
            this.obj.pciModeloItemComparar.valores = null
            this.obj.pciModeloItemComparar.formula = null
            this.obj.pciModeloItemComparar.validacoes = null

            this.onCloseModalCompareItems()
          })
          .finally(() => {
            this.searchingCompareItem = false
          })
      } else {
        this.obj.pciModeloItemComparar = null
        this.onCloseModalCompareItems()
      }
    },
    onSelectCompareFixedItem (item) {
      this.obj.pciModeloItemIDComparar = null
      this.itemModal.hide()

      if (item) {
        const fatherId = parseInt(item.code / 10) * 10
        const prefix = this.form.pciItemFixo.options.filter(fi => fi.code === fatherId)[0].text

        this.form.pciItemFixo.parents = prefix + ' > ' + this.form.pciItemFixo.options.filter(fi => fi.code === item.code)[0].text
        this.obj.pciItemFixoComparar = item.code
      }
      this.onCloseModalCompareItems()
    },
    onRemove (obj) {
      const idx = this.objList.findIndex(o => o.id === obj.id)
      this.objList.splice(idx, 1)
    },
    onNewNotifyGroup () {
      if (!this.value.statusValorGrupos) {
        this.value.statusValorGrupos = []
      }
      if (this.value.statusValorGrupos.find((x) => x.name === this.selected) || this.selected == null) {
        return
      }
      let statusValorGrupo = this.notificationGroupList.find((x) => x.value === this.selected)
      const data = {
        name: statusValorGrupo.value,
        id: '00000000-0000-0000-0000-000000000000',
        pciModeloItemStatusValorID: this.value.pciModeloItemStatusValorID,
        grupoNotificacaoId: statusValorGrupo.id
      }
      this.value.statusValorGrupos.push(data)
      this.selected = null
    },
    onRemoveNotifyGroup (index) {
      this.value.statusValorGrupos.splice(index, 1)
    },
    getNotificationGroups () {
      // loading.push()
      // NotificationGroupRepository.GetAll()
      //   .then(response => {
      //     if (response.data.code > 0) {
      //       response.data.data.forEach(e => {
      //         this.notificationGroupList.push({
      //           value: e.descricao,
      //           text: e.descricao,
      //           id: e.id
      //         })
      //       })
      //       if (this.value.statusValorGrupos && this.notificationGroupList) {
      //         this.value.statusValorGrupos.forEach(g => {
      //           let option = this.notificationGroupList.find((o) => o.id === g.grupoNotificacaoID)
      //           if (option) {
      //             g.name = option.text
      //           }
      //         })
      //       }
      //     } else {
      //       toast.error(response.data.message)
      //     }
      //   })
      //   .catch(err => {
      //     this.onException(err)
      //   })
      //   .finally(() => {
      //     loading.close()
      //   })
    },
    onValidationWarning ({ hasWarning }) {
      this.$emit('validation-warning', hasWarning)
    }
  }
}
</script>

<style scoped>
  #modalItems, #modalCompareItems {
    height: calc(100vh - 250px);
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/items/addValidationAutomation.vue